import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { TasksNewTaskForm } from "./TasksNewTaskForm";

export function TasksNewPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-brand-gray px-4 py-6 text-brand-blue">
      <div className="mx-auto max-w-2xl">
        <button
          type="button"
          onClick={() => navigate("/tasks", { replace: true })}
          className="inline-flex items-center gap-2 text-sm font-semibold text-brand-blue/80"
        >
          <ArrowLeft className="h-4 w-4" />
          Back to list
        </button>

        <p className="mt-6 font-display text-2xl font-bold">New task</p>
        <p className="mt-1 text-sm text-brand-blue/70">Fill in the details and save to return to the list.</p>

        <div className="mt-6 rounded-2xl bg-white p-4 shadow-sm ring-1 ring-black/5">
          <TasksNewTaskForm
            onSaved={() => navigate("/tasks", { replace: true })}
            onCancel={() => navigate("/tasks", { replace: true })}
          />
        </div>
      </div>
    </div>
  );
}
